import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson49: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[6.25rem] box-border gap-[6.88rem] text-justify text-[1.56rem] text-darkgray font-nunito">
    <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset"/>
      <div className="self-stretch flex flex-row items-center justify-between text-left">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson48"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Post-Workout Meal
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson50"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[4.63rem] max-w-[102.63rem] text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            After a hard workout, your body is in need of nutrients to help it
            recover and rebuild muscle. A post-workout meal is a great way to
            provide your body with the nutrients it needs to repair and
            strengthen your muscles.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            A post-workout meal should be high in protein and carbohydrates.
            Protein is essential for muscle repair and growth, while
            carbohydrates provide your body with energy. A good post-workout
            meal should also include fruits and vegetables, which are packed
            with vitamins, minerals, and antioxidants.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            There are a few different things you can eat for a post-workout
            meal. Some popular options include:
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <span>
            <b>A protein shake:</b>
          </span>
          <span className="text-gainsboro-100">
            <span> </span>
            <span>
              A protein shake is a great option for a post-workout meal because
              it is quick and easy to make, and it is a good source of protein
              and carbohydrates. You can make your own protein shake at home, or
              you can buy a pre-made protein shake.
            </span>
          </span>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f6@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <b>A bowl of oatmeal with fruit:</b>
          <span className="text-gainsboro-100">
             Oatmeal is a good source of carbohydrates and fiber, and it is also
            a good source of protein if you add some nuts or seeds to it. Top
            your oatmeal with some fruit for a nutrient-rich post-workout meal.
          </span>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f7@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <b>A turkey sandwich on whole-wheat bread: </b>
          <span className="text-gainsboro-100">
            A turkey sandwich on whole-wheat bread is a good source of protein
            and carbohydrates. Choose lean turkey and whole-wheat bread to make
            this a healthy post-workout meal.
          </span>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f8@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <b>A grilled chicken breast with vegetables:</b>
          <span className="text-gainsboro-100">
             Grilled chicken breast is a good source of protein, and vegetables
            are a good source of vitamins, minerals, and fiber. This is a
            healthy and satisfying post-workout meal.
          </span>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f9@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-white">
          <b>A banana with peanut butter:</b>
          <span className="text-gainsboro-100">
             A banana with peanut butter is a good source of carbohydrates,
            protein, and fiber. This is a quick and easy post-workout snack that
            will help you recover from your workout.
          </span>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/f10@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            It is important to eat your post-workout meal within 30 minutes of
            finishing your workout. This will help your body to absorb the
            nutrients and start the recovery process.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you are short on time, you can also have a quick post-workout
            snack. Some good options for post-workout snacks include:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">A handful of nuts</li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">A piece of fruit</li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li className="mb-[false]">A yogurt</li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 font-inherit text-inherit pl-[1.32rem]">
            <li>A hard-boiled egg</li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <span>
              <span>
                Here are some additional tips for eating a post-workout meal:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span className="text-white">
                Choose foods that are easy to digest.
              </span>
            </b>
            <span>
              <span>
                 After a workout, your body is already working hard to recover.
                Eating foods that are easy to digest will help your body absorb
                the nutrients it needs more easily.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span className="text-white">
                Avoid foods that are high in fat or sugar.
              </span>
            </b>
            <span>
              <b> </b>
              <span>
                Fat and sugar can slow down your body's ability to absorb
                nutrients. Instead, choose foods that are low in fat and sugar.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <b>
              <span className="text-white">Drink plenty of water.</span>
            </b>
            <span>
              <b> </b>
              <span>
                Water is essential for good health, and it is especially
                important after a workout. Drinking plenty of water will help
                your body stay hydrated and recover from your workout.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>The Importance of Taking Whey Protein After Working Out</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Whey protein is a type of protein that is quickly absorbed by the
            body. This makes it an ideal protein to consume after a workout,
            when your body is most in need of nutrients.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Whey protein can help to improve muscle recovery and growth. It can
            also help to reduce muscle soreness.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you are looking to improve your muscle mass and strength, then
            whey protein is a great supplement to consider.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>The Protein Synthesis Process</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Protein synthesis is the process by which your body builds new
            proteins. This process is essential for muscle growth and repair.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            There are a few things that can affect protein synthesis, including:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>The amount of protein you consume</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>The quality of the protein you consume</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>The timing of your protein intake</span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            After a workout, your body is more sensitive to protein. This means
            that you can get more benefits from consuming protein after a
            workout.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you are looking to improve your muscle growth and repair, then it
            is important to consume protein after a workout.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Here are some tips for maximizing protein synthesis after a workout:
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Consume 20-25 grams of protein within 30 minutes of finishing
                your workout.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Choose a high-quality protein source, such as whey protein.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Combine your protein with carbohydrates, such as fruit or a
                whole-grain carbohydrate source.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            By following these tips, you can help to maximize protein synthesis
            and improve your muscle growth and repair.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">&nbsp;</p>
        </div>
      </div>
      <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-gainsboro-100 font-dm-sans">
        <p className="m-0 text-white">
          <b>Common Post-Workout Meal Mistakes</b>
        </p>
        <p className="m-0 text-[1.56rem]">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              Here are some common post-workout meal mistakes to avoid:
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b className="font-dm-sans">
              <span className="text-white">Not eating anything at all.</span>
            </b>
            <span>
              <b className="font-dm-sans"> </b>
              <span>
                This is one of the biggest mistakes people make. After a hard
                workout, your body is in need of nutrients to help it recover
                and rebuild muscle. If you don't eat anything after your
                workout, your body will start to break down muscle for energy.
                This can lead to muscle loss and fatigue.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b className="font-dm-sans text-white">Eating too much.</b>
            <span>
              <span>
                 It's important to eat after a workout, but it's also important
                not to eat too much. Eating too much after a workout can lead to
                weight gain.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <b>&nbsp;</b>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b>
              <span className="text-white">Eating unhealthy foods. </span>
            </b>
            <span>
              <span>
                It's important to eat healthy foods after a workout. Eating
                unhealthy foods can sabotage your fitness goals.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                Not drinking enough water. It's important to stay hydrated,
                especially after a workout. Drinking plenty of water will help
                your body recover from your workout.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                Here are some tips for avoiding common post-workout meal
                mistakes:
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <b>&nbsp;</b>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b>
              <span className="text-white">
                Plan your post-workout meal ahead of time.
              </span>
            </b>
            <span> This will help you avoid making unhealthy choices.</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b className="font-dm-sans text-white">Eat a balanced meal.</b>
            <span>
               Your post-workout meal should include protein, carbohydrates, and
              healthy fats.
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b className="font-dm-sans text-white">Listen to your body.</b>
            <span> If you're not hungry, don't force yourself to eat.</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b className="font-dm-sans text-white">Drink plenty of water. </b>
            <span>
              Water is essential for good health, and it's especially important
              after a workout.
            </span>
          </span>
        </p>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson50"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson49;
